import AppsPartnerships from "@/components/Apps/AppsPartnerships";
import CreatorPartnerships from "@/components/Creators/CreatorPartnerships";
import { createFileRoute } from "@tanstack/react-router";
import { useAccount } from "@/state/useAccount";
import { z } from "zod";

const partnershipsSearchSchema = z.object({
  campaignId: z.string().optional(),
});

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/partnerships/",
)({
  component: Partnerships,
  validateSearch: partnershipsSearchSchema,
});

export default function Partnerships() {
  const { creatorId, appId } = useAccount();
  const search = Route.useSearch();

  return creatorId ? (
    <CreatorPartnerships />
  ) : appId ? (
    <AppsPartnerships campaignId={search.campaignId} />
  ) : null;
}
